import { render } from "./IdLabel.vue?vue&type=template&id=1b93e6a1&scoped=true"
import script from "./IdLabel.vue?vue&type=script&lang=js"
export * from "./IdLabel.vue?vue&type=script&lang=js"

import "./IdLabel.vue?vue&type=style&index=0&id=1b93e6a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b93e6a1"]])

export default __exports__